import { render, staticRenderFns } from "./ItemSalesReport.vue?vue&type=template&id=3d22260b"
import script from "./ItemSalesReport.vue?vue&type=script&lang=js"
export * from "./ItemSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports